import React from 'react'
import HomeBanner from "../components/HomeBanner"
import OverlappingCards from "../components/OverlappingCards"
import Separate from '../components/Separate'
import BeforeAfterSlider from "../components/BeforeAfterSlider"
import StickySection from "../components/StickySection"
import FaqSection from '../components/FaqSection'
import StayWithUs from '../components/StayWithUs'
import HomeAbout from '../components/HomeAbout'
import WhyDifferent from '../components/WhyDifferent'
import HomeProducts from '../components/HomeProducts'
import "./Home.css"

function Home() {
  return (
    <div>



 <h1 className="seo-h1">
         ACP Sheets Manufacturer in India
      </h1>
<p className="seo-intro">
  Alutuff manufactures premium aluminium composite panels for facade,
  exterior, interior and signage applications across India.
</p>

      <HomeBanner />
      <HomeAbout />
      <HomeProducts />
      {/* <WhyDifferent /> */}
      <OverlappingCards />
      <BeforeAfterSlider />
      <StickySection />
      <FaqSection />

      <div style={{ marginBottom: "-5%" }}>
        <StayWithUs />
      </div>
    </div>
  )
}

export default Home
